<template>
  <div class="form-client-details">
    <p
      v-show="!innIsDefined"
      class="insurance-chosen-variant__subtitle"
    >
      Заполните форму, чтобы произвести расчет
    </p>

    <h3 v-show="!innIsDefined" class="insurance-chosen-variant__title">Укажите страхователя</h3>

    <h3 v-show="innIsDefined" class="insurance-chosen-variant__title">Данные страхователя</h3>

    <p
      v-show="innIsDefined"
      class="insurance-chosen-variant__subtitle"
    >
      Проверьте заполненные данные и внесите информацию в пустые поля
    </p>

    <ElForm class="form-client-details__form form"
            ref="clientFormRef"
            :model="clientForm"
            :rules="rules"
            @submit.native.prevent
    >
      <ElRadioGroup v-show="!innIsDefined"
                    id="client-insurance-type"
                    v-model="clientForm.insuranceType"
                    size="large"
                    @change="handleSelectType"
      >
        <ElRadioButton
          v-input-id="'client-type-ul'"
          label="ul"
        >
          Юридическое лицо
        </ElRadioButton>
        <ElRadioButton
          v-input-id="'client-type-ip'"
          label="ip"
        >
          ИП
        </ElRadioButton>
        <ElRadioButton
          v-input-id="'client-type-fl'"
          label="fl"
        >
          Самозанятый
        </ElRadioButton>
      </ElRadioGroup>
      <p
        v-if="!innIsDefined"
        class="insurance-chosen-variant__subtitle"
      >
        Введите ИНН и Мы автоматически заполним ваши данные
      </p>

      <ElFormItem class="form__item"
                  prop="inn"
                  :error="innErrorText"
      >
        <ElInput id="client-inn" v-model="clientForm.inn"
                 placeholder="Введите ИНН"
                 v-mask="{regex: '^[0-9]{10}[0-9]{0,2}'}"
                 :disabled="innIsDefined"
                 @input="innErrorText = ''"
        >
          <template #prefix>
            ИНН
          </template>
          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElInput>
      </ElFormItem>
      <p
        v-if="!innIsDefined"
        class="insurance-chosen-variant__subtitle"
      >
        Для оформления полиса ОСГОП необходимо приложить разрешение на перевозку пассажиров и багажа легковым транспортом
      </p>
      <ElFormItem
        class="form__col form__col-half-not-line"
        prop="taxiFile"
        v-if="!innIsDefined"
        :error="taxiFileErrorText"
      >
        <ElUpload
          :file-list="clientForm.taxiFile"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          action="ajax/checkFile.php"
          accept="application/pdf,image/*"
          :before-upload="beforeUpload"
        >
          <BaseButton text="Загрузить разрешение"/>
          <template #tip>
            <div class="el-upload__tip taxi-file-tip">
              Файл в формате .pdf или изображение
              <br>
              Проверить наличие разрешения можно на сайте
              <a
                href="https://sicmt.ru/fgis-taksi"
                target="_blank"
              >
                ФГИС «Такси»
              </a>
            </div>
          </template>
        </ElUpload>
      </ElFormItem>

      <ElFormItem class="form__item"
                  prop="isProlongation"
                  v-if="!innIsDefined"
      >
        <el-checkbox
          v-input-id="'client-prolongation'"
          v-model="clientForm.isProlongation"
          class="checkbox-prolongation"
        >
          Хочу продлить имеющийся договор страхования
        </el-checkbox>
      </ElFormItem>

      <ElFormItem class="form__item prolongation-number"
                  prop="prolongationNumber"
                  v-if="!innIsDefined && clientForm.isProlongation"
                  :error="prolongationNumberErrorText"
                  key="prolongationNumberItem"
      >
        <ElInput id="client-prolongation-number" v-model="clientForm.prolongationNumber"
                 placeholder="Введите номер предыдущего договора страхования"
                 @input="prolongationNumberErrorText = ''"
                 v-mask="{mask: 'ROSX99999999999999'}"
        >
          <template #prefix>
            Номер предыдущего договора страхования
          </template>
          <el-tooltip content="Введите цифры из номера договора" placement="top" slot="suffix">
            <i class="form__item-icon-tooltip"></i>
          </el-tooltip>
        </ElInput>

      </ElFormItem>

      <ElFormItem class="form__item"
                  prop="isShortTerm"
                  v-if="!innIsDefined && (clientForm.insuranceType === 'ip' || clientForm.insuranceType === 'fl')"
      >
        <el-checkbox
          v-input-id="'client-short-term'"
          v-model="clientForm.isShortTerm"
          class="checkbox-prolongation"
        >
          Хочу заключить полис со сроком действия менее одного года
        </el-checkbox>
      </ElFormItem>

      <!--      Юр лицо-->
      <ElFormItem class="form__item"
                  prop="kpp"
                  :error="innErrorText"
                  v-if="innIsDefined && clientForm.insuranceType === 'ul'"
      >
        <ElInput id="client-kpp" v-model="clientForm.kpp"
                 placeholder="Введите КПП"
                 :disabled="clientForm.kpp"
                 @input="innErrorText = ''"
        >
          <template #prefix>
            КПП
          </template>
          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElInput>
      </ElFormItem>


      <ElFormItem
        class="form__item"
        prop="name"
        v-if="innIsDefined && clientForm.insuranceType === 'ul'"
      >
        <ElInput id="client-name"
          v-model="clientForm.name"
          placeholder="Наименование"
          :disabled="innIsDefined"
          v-if="innIsDefined && clientForm.insuranceType === 'ul'"
        >
          <template #prefix>
            Наименование
          </template>
          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        class="form__item"
        prop="address"
        v-if="innIsDefined && clientForm.insuranceType === 'ul'"
      >
        <ElAutocomplete v-input-id="'client-address'" class="form__item"
                        v-model="clientForm.address"
                        :fetch-suggestions="fetchAddressSuggestions"
                        placeholder="Выберите адрес"
                        :popper-append-to-body="false"
                        value-key="value"
                        v-on:input="clearParams"
                        @select="handleSelect"
        >
          <template #prefix v-if="clientForm.insuranceType !== 'ul'">
            Адрес регистрации
          </template>
          <template #prefix v-else>
            Юридический адрес
          </template>
        </ElAutocomplete>
      </ElFormItem>

      <div
        v-if="innIsDefined && clientForm.insuranceType === 'ul'"
        class="form__item form__item--col"
      >
        <ElFormItem class="form__col form__col--half"
                    prop="management_name">
          <ElInput id="client-management-name" v-model="clientForm.management_name"
                   placeholder="ФИО контактного лица">
            <template #prefix>
              ФИО контактного лица
            </template>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="form__col form__col--half"
                    prop="management_post"
        >
          <ElInput id="client-management-post"
            v-model="clientForm.management_post"
            placeholder="Должность контактного лица">
            <template #prefix>
              Должность руководителя
            </template>
          </ElInput>
        </ElFormItem>
      </div>


      <!--      ИП-->

      <ElFormItem
        class="form__item"
        v-if="innIsDefined && clientForm.insuranceType === 'ip'"
        prop="management_name"
      >
        <ElInput id="client-management-name" v-model="clientForm.management_name"
                 placeholder="ФИО контактного лица">
          <template #prefix>
            ФИО контактного лица
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        class="form__item"
        prop="address"
        v-if="innIsDefined && clientForm.insuranceType === 'ip'"
      >
          <ElAutocomplete v-input-id="'client-address'" class="form__item"
                        v-model="clientForm.address"
                        :fetch-suggestions="fetchAddressSuggestions"
                        placeholder="Выберите адрес"
                        :popper-append-to-body="false"
                        value-key="value"
                        v-on:input="clearParams"
                        @select="handleSelect"
        >
          <template #prefix v-if="clientForm.insuranceType !== 'ul'">
            Адрес регистрации
          </template>
          <template #prefix v-else>
            Юридический адрес
          </template>
        </ElAutocomplete>
      </ElFormItem>

      <div
        v-if="innIsDefined && clientForm.insuranceType === 'ip'"
        class="form__item form__item--col"
      >
        <ElFormItem class="form__col form__col--half"
                    prop="birth_date">
          <ElDatePicker v-input-id="'client-birth-date'" v-model="clientForm.birth_date"
                        v-mask="{mask: '9{2}.9{2}.9{4}'}"
                        ref="birthPicker"
                        type="date"
                        placeholder="дд.мм.гггг"
                        :default-value="subYears(new Date(), 18)"
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="{ disabledDate: (time) => disableInvalidBirthDates(time) }"
          >
          </ElDatePicker>
          <span class="form__label">Дата рождения</span>
        </ElFormItem>

        <ElFormItem
          class="form__col form__col--half"
          prop="sex"
          v-if="innIsDefined && clientForm.insuranceType === 'ip'"
        >
          <ElSelect v-input-id="'client-sex'"
            v-model="clientForm.sex"
            placeholder="Пол"
            :popper-append-to-body="false"
            @change="(item) => formSelectHandler(item, 'sex')"
            @blur="genderBlurHandler"
          >
            <template #prefix>
              Пол
            </template>

            <ElOption
              v-for="(option, index) in genders"
              :key="index"
              :label="option.label"
              :value="option.value"
            >
            </ElOption>
          </ElSelect>
        </ElFormItem>
      </div>

      <ElFormItem v-if="innIsDefined && clientForm.insuranceType === 'ip'"
                  class="form__item"
                  prop="passport_number"
                  key="passportNumberIp"
      >
        <ElInput id="client-passport-number" v-model="clientForm.passport_number"
                 placeholder="Серия и номер паспорта"
                 v-mask="{regex: '^[0-9]${2} [0-9]${2} [0-9]${6}'}"
        >
          <template #prefix>
            Серия и номер паспорта
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem class="form__item"
                  prop="passport_issue_date"
                  v-if="innIsDefined && clientForm.insuranceType === 'ip'"
      >
        <ElDatePicker v-input-id="'client-passport-issue-date'"
                      v-model="clientForm.passport_issue_date"
                      v-mask="{mask: '9{2}.9{2}.9{4}'}"
                      type="date"
                      placeholder="дд.мм.гггг"
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :default-value="passportIssueMinDate"
                      :disabled="!birthDateIsFilled"
                      :picker-options="{ disabledDate: (time) => disableInvalidPassportIssueDates(time) }"
                      @click.native="closeBirthPicker"
        >
        </ElDatePicker>
        <span class="form__label">Дата выдачи паспорта</span>
      </ElFormItem>


      <!--      Физ лицо-->

      <ElFormItem
        class="form__item"
        v-if="innIsDefined && clientForm.insuranceType === 'fl'"
        prop="management_name"
      >
        <ElInput id="client-management-name" v-model="clientForm.management_name"
                 placeholder="ФИО контактного лица">
          <template #prefix>
            ФИО контактного лица
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        class="form__item"
        prop="address"
        v-if="innIsDefined && clientForm.insuranceType === 'fl'"
      >
        <ElAutocomplete v-input-id="'client-address'" class="form__item"
                        v-model="clientForm.address"
                        :fetch-suggestions="fetchAddressSuggestions"
                        placeholder="Выберите адрес"
                        :popper-append-to-body="false"
                        value-key="value"
                        v-on:input="clearParams"
                        @select="handleSelect"
        >
          <template #prefix v-if="clientForm.insuranceType !== 'ul'">
            Адрес регистрации
          </template>
          <template #prefix v-else>
            Юридический адрес
          </template>
        </ElAutocomplete>
      </ElFormItem>

      <div
        v-if="innIsDefined && clientForm.insuranceType === 'fl'"
        class="form__item form__item--col"
      >
        <ElFormItem class="form__col form__col--half"
                    prop="birth_date">
        <ElDatePicker v-input-id="'client-birth-date'" v-model="clientForm.birth_date"
                        v-mask="{mask: '9{2}.9{2}.9{4}'}"
                        ref="birthPicker"
                        type="date"
                        placeholder="дд.мм.гггг"
                        :default-value="subYears(new Date(), 18)"
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="{ disabledDate: (time) => disableInvalidBirthDates(time) }"
          >
          </ElDatePicker>
          <span class="form__label">Дата рождения</span>
        </ElFormItem>

        <ElFormItem
          class="form__col form__col--half"
          prop="sex"
          v-if="innIsDefined && clientForm.insuranceType === 'fl'"
        >
          <ElSelect v-input-id="'client-sex'"
            v-model="clientForm.sex"
            placeholder="Пол"
            :popper-append-to-body="false"
            @change="(item) => formSelectHandler(item, 'sex')"
            @blur="genderBlurHandler"
          >
            <template #prefix>
              Пол
            </template>

            <ElOption
              v-for="(option, index) in genders"
              :key="index"
              :label="option.label"
              :value="option.value"
            >
            </ElOption>
          </ElSelect>
        </ElFormItem>
      </div>

      <ElFormItem v-if="innIsDefined && clientForm.insuranceType === 'fl'"
                  class="form__item"
                  prop="passport_number"
                  key="passportNumberFl"
      >
        <ElInput id="client-passport-number" v-model="clientForm.passport_number"
                 placeholder="Серия и номер паспорта"
                 v-mask="{regex: '^[0-9]${2} [0-9]${2} [0-9]${6}'}"
        >
          <template #prefix>
            Серия и номер паспорта
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem class="form__item"
                  prop="passport_issue_date"
                  v-if="innIsDefined && clientForm.insuranceType === 'fl'"
      >
        <ElDatePicker v-input-id="'client-passport-issue-date'"
                      v-model="clientForm.passport_issue_date"
                      v-mask="{mask: '9{2}.9{2}.9{4}'}"
                      type="date"
                      placeholder="дд.мм.гггг"
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :default-value="passportIssueMinDate"
                      :disabled="!birthDateIsFilled"
                      :picker-options="{ disabledDate: (time) => disableInvalidPassportIssueDates(time) }"
                      @click.native="closeBirthPicker"
        >
        </ElDatePicker>
        <span class="form__label">Дата выдачи паспорта</span>
      </ElFormItem>


      <div v-if="innIsDefined"
           class="form__item form__item--col">
        <ElFormItem class="form__col form__col--half"
                    prop="phone_number">
          <ElInput id="client-phone-number" v-model="clientForm.phone_number"
                   placeholder="Телефон"
                   v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
          >
            <template #prefix>
              Телефон
            </template>
          </ElInput>
        </ElFormItem>
        <ElFormItem class="form__col form__col--half"
                    prop="email"
        >
          <ElInput id="client-email"
            v-model="clientForm.email"
            type="email"
            placeholder="E-mail">
            <template #prefix>
              E-mail
            </template>
          </ElInput>
        </ElFormItem>
      </div>

      <div class="form__buttons">
        <BaseButton v-show="innIsDefined"
                    text="Назад"
                    theme="muted"
                    size="large"
                    is-text
                    @click.native="onClose"/>
        <BaseButton text="Продолжить"
                    size="large"
                    :is-disabled="submitIsDisabled"
                    @click.native="onSubmit($refs.clientFormRef)"/>
      </div>
    </ElForm>
    <ModalPolicyIssuanceError title="Невозможно оформить полис"
                              text="Для указанного вами юридического лица оформление полиса онлайн недоступно."
                              :visible="showErrorModal"
                              modal-width="719px"
                              @close="showErrorModal = false"/>

    <ModalPolicyIssuanceError title="Невозможно оформить полис"
                              text="Указан недействующий ИНН. Для заключения договора обратитесь в офис"
                              :visible="showErrorModalOffice"
                              modal-width="719px"
                              @close="showErrorModalOffice = false"/>

    <ModalPolicyIssuanceError title="Невозможно оформить полис"
                              :text="messageMainModal"
                              :visible="showErrorModalMain"
                              modal-width="719px"
                              @close="showErrorModalMain = false"/>

    <ModalPolicyIssuanceProlong
                              :visible="showErrorModalProlong"
                              :text="messageProlongModal"
                              modal-width="719px"
                              @close="showErrorModalProlong = false"
                              @prolong="changeNewTypeBusiness"
    />
  </div>
</template>

<script>
import {subYears, addYears, subDays, parse} from 'date-fns';
import BaseButton from '@/components/ui/BaseButton';
import ModalPolicyIssuanceError from '@/components/modals/ModalPolicyIssuanceError';
import ModalPolicyIssuanceProlong from '@/components/modals/ModalPolicyIssuanceProlong';
import {numbersLengthFromString, matchesEmailRegex} from '@/utils/string-helpers';
import {validationHandler, getValidDate, clientPassportIssueIsInvalid, isValidDate} from '@/utils/validation';
import {
  PERSON_INN_LENGTH,
  PHONE_LENGTH,
  PERSON_PASSPORT_LENGTH,
  PASSPORT_ISSUE_DATE_LENGTH,
  INN_VALID_MAP,
  INN_ERRORS_MAP,
  ORGANIZATION_TYPES_MAP
} from '@/consts';
import {getOrganizationInfo, asyncGetKuv} from '@/api/routes/inn';
import {getProlongationAgreementInfo} from '@/api/routes/agreement';
import {checkPassport} from '@/api/routes/passport';
import {fetchAddressSuggestions} from '@/utils/api-helpers';
import {Notification} from "element-ui";

export default {
  name: 'FormClientDetails',
  components: {
    BaseButton,
    ModalPolicyIssuanceError,
    ModalPolicyIssuanceProlong,
  },
  inject: ['setShowGlobalSpinner'],
  data() {
    return {
      clientForm: {
        insuranceType: 'ul',
        inn: '',
        taxiFile: [],
        isProlongation: false,
        isShortTerm: false,
        prolongationNumber: '',
        name: '',
        address: '',
        phone_number: '',
        email: '',
        type_of_client: '',
        management_name: '',
        management_post: '',
        passport_number: '',
        birth_date: '',
        passport_issue_date: '',
        fias_id: '',
        house: '',
        houseGuid: '',
        isSetSuggest: false,
        isSetSuggestManual: false,
        kpp: '',
        sex: 'M',
        prolongationAgreement: {},
      },
      sentInnKuvAsync: [],
      genders: [{
        value: 'M',
        label: 'Мужской'
      }, {
        value: 'F',
        label: 'Женский'
      }],
      rules: {
        inn: [
          {required: true, message: 'Поле ИНН обязательно для заполнения', trigger: 'blur'},
          {
            validator: (rule, val, resolve) => validationHandler(this.innLengthIsValid, `Поле ИНН должно содержать ${this.getInnLength} символов`, resolve),
            trigger: 'blur'
          },
          {
            validator: (rule, val, resolve) => validationHandler(this.innFlValid, `Введен некорректный ИНН`, resolve),
            trigger: 'blur'
          }
        ],
        prolongationNumber: [
          {
            validator: (rule, val, resolve) => validationHandler(this.prolongationNumberRequiredIsValid, 'Поле Номер предыдущего договора обязательно для заполнения', resolve),
            trigger: 'blur'
          },
          {
              validator: (rule, val, resolve) => validationHandler(this.checkProlongationNumber, 'Некорректный номер предыдущего договора', resolve),
              trigger: 'blur'
          }
        ],
        taxiFile: [
          {required: true, message: 'Необходимо загрузить разрешение', trigger: 'blur'},
        ],
        address: [

          {required: true, message: 'Поле адреса обязательно для заполнения', trigger: 'blur'},
          {
            validator: (rule, val, resolve) => validationHandler(this.addressIsValid, this.addressError, resolve),
            trigger: 'blur'
          }
        ],
        email: [
          {required: true, message: 'Введите e-mail', trigger: 'blur'},
          {
            validator: (rule, val, resolve) => validationHandler(this.emailFormatIsValid, 'Неверный формат электронной почты!', resolve),
            trigger: 'blur'
          },
        ],
        phone_number: [
          {required: true, message: 'Введите номер телефона', trigger: 'blur'},
          {
            validator: (rule, val, resolve) => validationHandler(this.phoneLengthIsValid, `Номер телефона должен содержать ${PHONE_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        passport_number: [
          {required: true, message: 'Введите серию и номер паспорта', trigger: 'blur'},
          {
            validator: (rule, val, resolve) => validationHandler(this.passportLengthIsValid, `Данные должны содержать ${PERSON_PASSPORT_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        management_name: [
          {required: true, message: 'Заполните ФИО руководителя', trigger: 'blur'}
        ],
        management_post: [
          {required: true, message: 'Заполните должность руководителя', trigger: 'blur'}
        ],
        passport_issue_date: [
          {
            validator: (rule, val, resolve) => {
              validationHandler(this.validatePassportIssueDate, `Дата выдачи паспорта указана неверно`, resolve)
            },
            trigger: 'blur'
          },
          {required: true, message: 'Введите дату выдачи паспорта', trigger: 'change'},
        ],
        sex: [
          {required: true, message: 'Поле пол обязательно для заполнения', trigger: 'blur'},
        ],
      },
      innErrorText: '',
      taxiFileErrorText: '',
      prolongationNumberErrorText: '',
      innIsDefined: false,
      showErrorModal: false,
      showErrorModalOffice: false,
      showErrorModalMain: false,
      showErrorModalProlong: false,
      messageMainModal: 'Некорректный запрос',
      messageProlongModal: 'Номер предыдущего договора некорректен',
    }
  },
  watch: {
    'clientForm.isShortTerm'(value) {
      this.$emit('short-term-change', value && this.clientForm.insuranceType !== 'ul');
    },
  },
  methods: {
    setProlongationError(agreementData) {
      const message = agreementData?.message ?? agreementData?.error;
      this.messageProlongModal = typeof message === 'string' && message.includes('уже пролонгирован')
        ? message
        : 'Номер предыдущего договора некорректен';
      this.showErrorModalProlong = true;
    },
    errorMessage(title, text) {
      Notification({
        title: title,
        message: text,
        type: 'error',
      })
    },
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      const isImage = file.type.startsWith('image/')

      if (
        !isPDF
        && !isImage
      ) {
        this.errorMessage('Вы можете загружать только PDF файлы или изображения');
        this.clientForm.taxiFile = [];
        return false;
      }

      this.taxiFileErrorText = '';

      return true;
    },
    handleFileRemove(file, fileList) {
      this.clientForm.taxiFile = [];
      this.taxiFileErrorText = 'Необходимо загрузить файл с разрешением на перевозку пассажиров и багажа легковым транспортом';
    },
    handleFileChange(file, fileList) {
      this.clientForm.taxiFile = fileList.slice(-1);
    },
    handleSelectType(item) {
      if (item === 'ul') {
        this.clientForm.isShortTerm = false;
      }
      this.$refs.clientFormRef.validateField('inn');
    },
    genderBlurHandler() {
      this.$refs.clientFormRef.validateField('sex');
    },
    formSelectHandler(data, formField) {
      this.clientForm[formField] = data;

      this.$refs.clientFormRef.validateField(formField);
    },
    async onSubmit(formEl) {
      if (!this.innIsDefined) {
        if (
          this.clientForm.insuranceType === 'ul'
          || this.clientForm.insuranceType === 'ip'
        ) {
          this.validateOrganizationByInn();
        } else {
          let isError = false;

          if (this.clientForm.taxiFile.length <= 0) {
            this.taxiFileErrorText = 'Необходимо загрузить файл с разрешением на перевозку пассажиров и багажа легковым транспортом';
            isError = true;
          }

          if (
            this.clientForm.isProlongation
            && !this.clientForm.prolongationNumber
          ) {
            this.prolongationNumberErrorText = 'Поле Номер предыдущего договора обязательно для заполнения';
            isError = true;
          }

          if (isError) {
            return;
          }

          if (
            this.clientForm.isProlongation
            && !!this.clientForm.prolongationNumber
          ) {
            this.setShowGlobalSpinner(true);
            const agreementData = await getProlongationAgreementInfo(this.clientForm.prolongationNumber, this.clientForm.inn);
            if (agreementData?.result) {
              this.clientForm.prolongationAgreement = agreementData?.agreement ?? {};
              this.setShowGlobalSpinner(false);
            } else {
              this.setProlongationError(agreementData);
              this.setShowGlobalSpinner(false);
              return;
            }
          }

          this.innIsDefined = true;

          if (!this.sentInnKuvAsync.includes(this.clientForm.inn)) {
            asyncGetKuv(this.clientForm.inn);
            this.sentInnKuvAsync.push(this.clientForm.inn);
          }
        }
      } else {
        formEl.validate(async (valid) => {
          if (valid) {
            if (
              this.clientForm.insuranceType === 'fl'
              || this.clientForm.insuranceType === 'ip'
            ) {
              this.setShowGlobalSpinner(true);
              const resultPassportCheck = await checkPassport(this.clientForm);

              if (resultPassportCheck?.isInvalid) {
                this.showErrorModalMain = true;
                this.messageMainModal = 'Для оформления договора обратитесь в офис';
                this.setShowGlobalSpinner(false);
                return;
              }
            }

            this.$emit('client-details-submit', this.clientForm);
            this.setShowGlobalSpinner(false);
          }
        })
      }
    },
    async validateOrganizationByInn() {
      this.innErrorText = '';

      try {
        let isError = false;

        if (this.clientForm.taxiFile.length <= 0) {
          this.taxiFileErrorText = 'Необходимо загрузить файл с разрешением на перевозку пассажиров и багажа легковым транспортом';
          isError = true;
        }

        if (
          this.clientForm.isProlongation
          && !this.clientForm.prolongationNumber
        ) {
          this.prolongationNumberErrorText = 'Поле Номер предыдущего договора обязательно для заполнения';
          isError = true;
        }

        if (isError) {
          return;
        }

        this.setShowGlobalSpinner(true);

        if (
          this.clientForm.isProlongation
          && !!this.clientForm.prolongationNumber
        ) {
          const agreementData = await getProlongationAgreementInfo(this.clientForm.prolongationNumber, this.clientForm.inn);
          if (agreementData?.result) {
            this.clientForm.prolongationAgreement = agreementData?.agreement ?? {};
          } else {
            this.setProlongationError(agreementData);
            this.setShowGlobalSpinner(false);
            return;
          }
        } else {
          this.clientForm.prolongationNumber = '';
          this.clientForm.prolongationAgreement = {};
        }

        const organizationData = await getOrganizationInfo(this.clientForm.inn, this.clientForm.insuranceType);

        const innValidatonStatus = typeof organizationData === 'string'
          ? INN_VALID_MAP[organizationData]
          : INN_VALID_MAP[organizationData?.valid_value]

        if (innValidatonStatus === 'success') {
          // ИНН найден и разрешен
          Object.assign(this.clientForm, organizationData);

          this.innIsDefined = true;
          this.$emit('inn-is-defined');
          this.$refs.clientFormRef.validateField('address');

          if (!this.sentInnKuvAsync.includes(this.clientForm.inn)) {
            asyncGetKuv(this.clientForm.inn);
            this.sentInnKuvAsync.push(this.clientForm.inn);
          }
        } else if (innValidatonStatus === 'forbidden') {
          // ИНН найден, но ОКВЭД запрещен
          this.showErrorModal = true;
        } else if (innValidatonStatus === 'liquidated') {
          // Компания или ИП ликвидирована
          this.showErrorModalOffice = true;
        } else if (innValidatonStatus === 'not_found') {
          // ИНН не найден, Ошибка поиска юридического лица по указанному ИНН
          this.innErrorText = INN_ERRORS_MAP[innValidatonStatus];
        } else if (innValidatonStatus === 'not_match') {
          // Не совпадает выбранный тип
          this.innErrorText = INN_ERRORS_MAP[innValidatonStatus];
        } else {
          // Произошла непредвиденная ошибка
          this.innErrorText = INN_ERRORS_MAP.uncaught_error;
        }
      } catch (err) {
        this.innErrorText = INN_ERRORS_MAP.uncaught_error;
      }

      this.setShowGlobalSpinner(false);
    },
    closeBirthPicker(e) {
      //Закрытие пикера с датой рождения, дополниельный обработчик потому по умолчанию
      // пикер с датой выдачи паспорта в disable и событие по умолчанию не отрабатывает
      this.$refs.birthPicker.handleClose();
    },
    validatePassportIssueDate() {
      if (!this.clientForm.passport_issue_date) {
        return false
      }
      return this.clientPassportIssueIsInvalid(this.clientForm.birth_date, this.clientForm.passport_issue_date);
    },
    disableInvalidBirthDates(birthDate) {
      const currentDate = new Date();
      const eighteenYearsAgo = subYears(currentDate, 18);
      const hundredYears = subYears(currentDate, 100);

      return birthDate.getTime() > eighteenYearsAgo.getTime() || birthDate.getTime() < hundredYears.getTime();
    },
    disableInvalidPassportIssueDates(issueDate) {
      if (!this.birthDateIsFilled) {
        return true
      }

      const birthDate = parse(this.clientForm.birth_date, 'dd.MM.yyyy', new Date());
      const today = new Date();

      let birthPlus14Years = addYears(birthDate, 14);

      if (issueDate < birthPlus14Years) {
        // дата выдачи паспорта должна быть больше чем дата рождения + 14 лет
        return true
      } else if (issueDate > subDays(today, 1)) {
        // дата выдачи паспорта должна быть меньше чем сегодня - один день
        return true
      }

      return false
    },
    onClose() {
      if (this.innIsDefined) {
        this.$emit('prev-step');
      } else {
        this.$emit('close');
      }

      this.innIsDefined = false;
    },
    changeNewTypeBusiness() {
      this.showErrorModalProlong = false;
      this.clientForm.prolongationNumber = '';
      this.clientForm.prolongationAgreement = {};
      this.clientForm.isProlongation = false;
      this.onSubmit(this.$refs.clientFormRef)

    },
    clearParams(val) {
      this.clientForm.isSetSuggest = false;
      this.clientForm.isSetSuggestManual = false;
      this.clientForm.house = '';
      this.clientForm.houseGuid = '';
      this.clientForm.fias_id = '';
    },

    handleSelect(item) {
      this.clientForm.isSetSuggest = true;

      if (item?.code && item.code === 'user_manual') {
        this.clientForm.isSetSuggestManual = true;
      }

      this.clientForm.house = item.house;
      this.clientForm.houseGuid = item.houseGuid;
      this.clientForm.fias_id = item.fiasId;

      this.$refs.clientFormRef.validateField('address');
    },

    clientPassportIssueIsInvalid,
    getValidDate,
    subYears
  },
  computed: {
    addressError() {
      if (!this.clientForm.isSetSuggest) {
        return 'Не выбран адрес из списка';
      }

      if (this.clientForm.isSetSuggest && !this.clientForm.isSetSuggestManual && !!!this.clientForm.houseGuid) {
        return 'Не указан номер дома';
      }

      return 'Поле обязательно для заполнения'
    },
    addressIsValid() {
      if (!this.clientForm.isSetSuggest) {
        return false;
      }

      if (this.clientForm.isSetSuggest && !this.clientForm.isSetSuggestManual && !!!this.clientForm.houseGuid) {
        return false;
      }

      return true;
    },
    innLengthIsValid() {
      if (this.clientForm.insuranceType === 'ul') {
        return numbersLengthFromString(this.clientForm.inn) == 10;
      } else if (this.clientForm.insuranceType === 'ip') {
        return numbersLengthFromString(this.clientForm.inn) == 12;
      } else {
        return numbersLengthFromString(this.clientForm.inn) == 12;
      }
    },
    innFlValid() {
      if (
        this.clientForm.insuranceType === 'fl'
        && this.innLengthIsValid
      ) {
        const coefficients1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
        const coefficients2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

        let sum1 = 0;
        for (let i = 0; i < 10; i++) {
          sum1 += parseInt(this.clientForm.inn[i]) * coefficients1[i];
        }

        let control1 = sum1 % 11;
        if (control1 === 10) {
          control1 = 0;
        }

        if (control1 !== parseInt(this.clientForm.inn[10])) {
          return false;
        }

        let sum2 = 0;
        for (let i = 0; i < 11; i++) {
          sum2 += parseInt(this.clientForm.inn[i]) * coefficients2[i];
        }

        let control2 = sum2 % 11;
        if (control2 === 10) {
          control2 = 0;
        }

        return control2 === parseInt(this.clientForm.inn[11]);
      }

      return true;
    },
    prolongationNumberRequiredIsValid() {
      return !this.clientForm.isProlongation
        || !!this.clientForm.prolongationNumber
    },
    checkProlongationNumber() {
      const pattern = /^ROSX\d{14}$/;

      return !!this.clientForm.prolongationNumber && pattern.test(this.clientForm.prolongationNumber)
    },
    getInnLength() {
      if (this.clientForm.insuranceType === 'ul') {
        return 10;
      } else if (this.clientForm.insuranceType === 'ip') {
        return 12;
      } else {
        return 12;
      }
    },
    phoneLengthIsValid() {
      return numbersLengthFromString(this.clientForm.phone_number) >= PHONE_LENGTH
    },
    emailIsFilled() {
      return this.clientForm.email.length !== 0
    },
    birthDateIsFilled() {
      return !!this.clientForm.birth_date?.length;
    },
    emailFormatIsValid() {
      return matchesEmailRegex(this.clientForm.email);
    },
    passportLengthIsValid() {
      return numbersLengthFromString(this.clientForm.passport_number) >= PERSON_PASSPORT_LENGTH;
    },
    passportIssueLengthIsValid() {
      return numbersLengthFromString(this.clientForm.passport_issue_date) >= PASSPORT_ISSUE_DATE_LENGTH;
    },
    passportIssueMinDate() {
      if (!this.clientForm.birth_date) {
        return '';
      }
      const birthDate = parse(this.clientForm.birth_date, 'dd.MM.yyyy', new Date());
      return addYears(birthDate, 14)
    },
    organizationTypesMap() {
      return ORGANIZATION_TYPES_MAP;
    },
    submitIsDisabled() {
      switch (this.innIsDefined) {
        case false:
          return !this.innLengthIsValid || !this.innFlValid;
        case true:
          const clientType = this.clientForm.type_of_client;

          if (clientType === ORGANIZATION_TYPES_MAP.individual) {
            return !this.phoneLengthIsValid
              || !this.passportLengthIsValid
              || !this.passportIssueLengthIsValid
              || !this.emailIsFilled;

          } else if (clientType === ORGANIZATION_TYPES_MAP.company) {
            return !this.phoneLengthIsValid || !this.emailIsFilled;
            ;
          }
      }
    },
    clientIsOrganization() {
      return this.clientForm.type_of_client === this.organizationTypesMap.company && this.innIsDefined
    },
    clientIsPerson() {
      return this.clientForm.type_of_client === this.organizationTypesMap.individual && this.innIsDefined
    },

    fetchAddressSuggestions
  },
}
</script>

<style scoped lang=scss>
.el-radio-group {
  @include text-medium($font-weight-regular, $line-height-medium);
  font-family: $font-family-secondary;
  margin-top: rem($gap-normal);
  margin-bottom: rem($gap-medium);
}

.insurance-chosen-variant {
  &__subtitle {
    @include text-medium($font-weight-regular, $line-height-medium);

    font-family: $font-family-secondary;

    margin-top: rem($gap-normal);
    margin-bottom: rem($gap-medium);
    width: fit-content;

    color: $color-text-muted-low2;

    @media #{$screen-big} {
      font-size: rem($font-size-normal);
    }
  }
}

.el-radio-button__inner {
  @media #{$screen-small} {
    padding: 12px 6px !important;
    font-size: 12px !important;
  }
}

.taxi-file-tip {
  line-height: rem(20px);
}


.el-checkbox {
  @include text-normal($font-weight-regular, $line-height-normal);

  color: $color-text;

  &__input {
    &.is-focus {
      .el-checkbox__inner {
        border-color: $primary;
      }
    }

    &.is-checked {
      .el-checkbox__inner {
        border-radius: rem($border-radius-micro);
        border-color: $primary;
        background-color: $primary;

        &::after {
          @include absolute-all-null;
          height: 100%;
          width: 100%;

          transform: scaleY(1);

          border: none;
          background-image: url("@/assets/images/icons/tick-white-bondi-blue-bg.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: rem($icon-size-tiny) rem($icon-size-tiny);

          @media (#{$screen-small}) {
            background-size: rem($icon-size-micro) rem($icon-size-micro);
          }
        }
      }
    }
  }

  &__inner {
    width: rem($icon-size-base);
    height: rem($icon-size-base);

    border-color: $tetriary;

    @media (#{$screen-small}) {
      width: rem($icon-size-small);
      height: rem($icon-size-small);
    }

    &:hover {
      border-color: $primary;
    }

    &::after {
      transform: scaleY(0);
      border: none;
    }

  }
}
</style>

<style lang=scss>
.checkbox-prolongation {
  display: flex;
  align-items: center;
  margin-bottom: rem(10px);

  & .el-checkbox__label {
    @include text-increased($font-weight-bold);
    color: #3d3d3d !important;
    font-size: rem($font-size-small);
    white-space: normal;
  }
}

.prolongation-number {
  margin-top: rem(5px) !important;
}
</style>
